export var urlFilename = function (url) {
  var path = url.substring(url.lastIndexOf("/") + 1);
  return (path.match(/[^.]+(\.[^?#]+)?/) || [])[0];
};